import { ChevronRight } from "@mui/icons-material";
import ArrowLeft from "@mui/icons-material/ArrowLeft";
import IconInfo from "@mui/icons-material/InfoOutlined";
import { Box, CircularProgress, Grid, Link, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { default as Libelle } from "../../../../_i18n/fr.json";
import Bouton from "../../../../components/Button/Bouton";
import CheminDeFer from "../../../../components/cheminDeFer/CheminDeFer";
import DialogStatut from "../../../../components/DialogStatut";
import FormContainer from "../../../../components/FormContainer";
import InputCheckbox from "../../../../components/inputCheckbox/InputCheckbox";
import LoadingBoundary from "../../../../components/LoadingBoundary";
import Statut from "../../../../components/Statut";
import Titre from "../../../../components/titre/Titre";
import { InlineObjectStatutEnum } from "../../../../services/Api/swagger";
import InfoCandidats from "./InfoCandidats";
import InfoDossier from "./InfoDossier";
import { useSynthese } from "./selectors";
import styles from "./styles";

function Synthese() {
  const {
    getSynthese,
    resetSituationPro,
    addColoc,
    addLocataire,
    setSelectedPerson,
    resetSelectedPerson,
    resetParcours,
    calculLoyerMax,
    forcerStatutDossier,
    getPartenaire,
    isFetchingPartenaire,
    isFetchingSynthese,
    errorSynthese,
    synthese,
    selectedDossier,
    infoProfil,
    utilisateurConnecte,
    isControleDossier,
    partenaire,
    calculLoyerFetching,
    calculLoyerError,
    forcerStatutFetching,
    compositionLocation,
    verifierDossierLocation,
    loadingVerifierDossierLocation,
    errorVerifierDossierLocation,
    handleForcerStatutDossier,
    infoSaisiesOk,
    infoAVerifier,
    handleClickInfoSaisies,
    canSeeParcoursLocataire,
  } = useSynthese();
  const isBesse = utilisateurConnecte?.role === "BESSE";
  const canModifyStatut =
    infoProfil &&
    infoProfil.fonctions &&
    infoProfil.fonctions.find((f) => f === "SYNTH_MODIFICATION_STATUT");
  const cantModify =
    (synthese &&
      synthese.statut &&
      (synthese.statut === "VALIDE_AGREE" ||
        synthese.statut === "VALIDE_AGREE_DIFFERE" ||
        synthese.statut === "VALIDE_NON_AGREE" ||
        synthese.statut === "NON_VALIDE" ||
        synthese.statut === "A_VERIFIER" ||
        (partenaire &&
          (synthese.statut === "EN_TRANSFERT" ||
            synthese.statut === "VALIDE")))) ||
    false;
  const messageStatut =
    synthese &&
    synthese.statut &&
    // @ts-ignore
    Libelle.messageStatutDossierLocation[synthese.statut];
  const nomPartenaire = partenaire ? partenaire.nom : undefined;
  const urlPartenaire =
    synthese && synthese.partenaire ? synthese.partenaire.urlFront : undefined;

  const displayLoyerMaxConseille =
    synthese &&
    (synthese.loyerMaxConseille || synthese.loyerMaxConseille === 0);
  // VALIDATION INFORMATIONS SAISIES
  return (
    <Box sx={styles}>
      <Grid container justifyContent="center">
        <Titre
          libelle={Libelle.pageSynthese.h1}
          variant="h1"
          isVisible={false}
        />
      </Grid>
      {/* Chemin de fer */}
      {!cantModify && <CheminDeFer isEtape="synthese" />}
      {cantModify && (
        <Grid
          container
          justifyContent="space-between"
          className={"containerLink"}
        >
          <Link href="/dashboard" color="inherit" className="backLink">
            <ArrowLeft /> Retour au dashboard
          </Link>
        </Grid>
      )}
      <div className={"synthese"}>
        <LoadingBoundary
          error={errorSynthese}
          loading={isFetchingPartenaire || isFetchingSynthese}
        >
          <>
            <Grid container direction="column" className={"containerStatut"}>
              <div className={"statut"}>
                <Grid container alignItems="center">
                  <p>
                    <strong>Statut :</strong>
                  </p>
                  {forcerStatutFetching ? (
                    <CircularProgress />
                  ) : (
                    <Statut statut={synthese && synthese.statut} />
                  )}
                  {canModifyStatut && (
                    <DialogStatut
                      handleForcerStatutDossier={handleForcerStatutDossier}
                    />
                  )}
                </Grid>
                {messageStatut && (
                  <Grid
                    container
                    alignItems="center"
                    className={"messageStatut"}
                  >
                    <IconInfo fontSize="small" />
                    <small>{messageStatut}</small>
                  </Grid>
                )}
              </div>
              <Grid
                container
                className={"loyermaxConseille"}
                alignItems="center"
              >
                <strong>
                  Loyer max conseillé :
                  {displayLoyerMaxConseille &&
                    " " + synthese.loyerMaxConseille + "€"}
                  {!infoSaisiesOk && !displayLoyerMaxConseille && (
                    <InputCheckbox
                      input={{
                        name: "infoSaisiesOk",
                        value: infoSaisiesOk,
                        onBlur: () => {},
                        onChange: () => {},
                        onFocus: () => {},
                      }}
                      meta={{}}
                      id="infoSaisiesOk"
                      name="infoSaisiesOk"
                      value={infoSaisiesOk}
                      label="En cochant cette case, le signataire du présent dossier certifie que les informations qu'il a saisies sont exactes et conformes aux documents et informations qui lui ont été transmis par le candidat locataire."
                      onChangeValue={handleClickInfoSaisies}
                    />
                  )}
                  {infoAVerifier && !displayLoyerMaxConseille && (
                    <Grid container alignItems={"center"}>
                      <ChevronRight fontSize="small" />
                      <Typography variant="body2">
                        Validez-vous les informations du dossier ?{" "}
                        <span className="infoverifier-red">
                          (Si existant merci de vérifier le VISA, le récépissé
                          de prolongation du titre de séjour ou le justificatif
                          étudiant)
                        </span>
                      </Typography>
                      <Bouton
                        label="Valider"
                        variant="contained"
                        color="primary"
                        size="small"
                        fetching={loadingVerifierDossierLocation}
                        onClick={() =>
                          synthese?.reference &&
                          verifierDossierLocation(synthese?.reference)
                        }
                      />
                    </Grid>
                  )}
                  {infoSaisiesOk &&
                    !infoAVerifier &&
                    !displayLoyerMaxConseille && (
                      <Bouton
                        label="Calcul loyer max"
                        variant="contained"
                        color="primary"
                        size="small"
                        fetching={calculLoyerFetching}
                        onClick={() => calculLoyerMax(synthese?.reference)}
                      />
                    )}
                </strong>
                {calculLoyerError && (
                  <Typography variant="caption" color="error">
                    La solvabilité ne peut être déterminée, Merci de corriger
                    les informations du dossier
                  </Typography>
                )}
                {errorVerifierDossierLocation && (
                  <Typography variant="caption" color="error">
                    Une erreur est survenue, veuillez réessayer plus tard.
                  </Typography>
                )}
                {isBesse &&
                  synthese &&
                  (synthese.loyerMaxConseille ||
                    synthese.loyerMaxConseille === 0) && (
                    <Link
                      underline="always"
                      href="/dossier-location/calcul-loyer"
                    >
                      détail du calcul
                    </Link>
                  )}
              </Grid>
            </Grid>

            <FormContainer>
              {synthese && (
                <>
                  <InfoDossier
                    data={synthese}
                    cantModify={cantModify}
                    nomPartenaire={nomPartenaire}
                    urlPartenaire={urlPartenaire}
                    typeDossier={compositionLocation}
                    parcours={
                      (canSeeParcoursLocataire &&
                        (synthese.parcoursCandidatLocataire
                          ? "candidat locataire"
                          : "adb")) ||
                      undefined
                    }
                  />
                  <InfoCandidats
                    data={synthese && synthese.dossiersParticuliers}
                    typeDossier={compositionLocation}
                    cantModify={cantModify}
                    isCandidatLocataire={synthese.parcoursCandidatLocataire}
                    addColoc={addColoc}
                    addLocataire={addLocataire}
                    selectedDossier={selectedDossier}
                    setSelectedPerson={setSelectedPerson}
                    statutDossier={synthese.statut}
                  />
                </>
              )}
            </FormContainer>
          </>
        </LoadingBoundary>
      </div>
      <Grid container spacing={10} justifyContent="space-between">
        <Grid item />
      </Grid>
    </Box>
  );
}

export default Synthese;
